import { createPortal } from "react-dom";

import { Column, Text } from "@/components";
import { ChamferOutline } from "@/components/chamfer";

import { leverPerformanceTierTextClass } from "@/lib/constants";
import { dashboardKpis } from "@/lib/dashboardKpis";
import { formatting } from "@/lib/formatting";
import { cn } from "@/lib/utils";
import { DashboardComparisonMetric, PerformanceTier } from "@/types";

const TOOLTIP_GAP_PX = 8;

// Follows the cursor across the bars, so it's portalled out of the card rather
// than clipped by it.
export const StafferComparisonTooltip = ({
  goal,
  isRanked,
  metric,
  name,
  tier,
  value,
  x,
  y,
}: {
  goal: number;
  isRanked: boolean;
  metric: DashboardComparisonMetric;
  name: string;
  tier: PerformanceTier;
  value: number;
  x: number;
  y: number;
}) =>
  createPortal(
    <Column
      className="lever-chart-tooltip pointer-events-none fixed z-50 overflow-hidden rounded-none border border-lever-border-light bg-lever-surface-default px-3 py-2 shadow-none"
      style={{
        left: x,
        top: y - TOOLTIP_GAP_PX,
        transform: "translate(-50%, -100%)",
      }}
    >
      <Column className="lever-chart-tooltip-surface">
        <ChamferOutline />
        <Text className="text-xs font-semibold text-lever-text-heading">
          {name}
        </Text>
        <Text
          className={cn(
            "font-lever-accent text-lg font-normal tabular-nums leading-tight",
            metric === DashboardComparisonMetric.REVENUE
              ? "text-lever-text-heading"
              : leverPerformanceTierTextClass[tier],
          )}
        >
          {isRanked ? dashboardKpis.formatValue(metric, value) : "—"}
        </Text>
        {metric === DashboardComparisonMetric.REVENUE ? (
          <Text className="text-xs font-normal text-lever-text-label">
            {formatting.currency(Math.max(goal - value, 0))} left to goal
          </Text>
        ) : null}
      </Column>
    </Column>,
    document.body,
  );
